import {animateInViewport} from './transition';

let jQueryBridget = require( 'jquery-bridget' );

$( function() {
} );


let resizeTimer;

$( window ).on( 'resize', function() {
	clearTimeout( resizeTimer ); // Clear the previous timer

	resizeTimer = setTimeout( function() {
	}, 100 );
} );
